import { ADD_GLOBAL_MAP, REMOVE_GLOBAL_MAP } from './actionTypes';

export const addGlobalMap = (map, order) => (dispatch) => {
  dispatch({
    type: ADD_GLOBAL_MAP,
    payload: map,
  });
};

export const removeGlobalMap = (map, order) => (dispatch) => {
  dispatch({
    type: REMOVE_GLOBAL_MAP,
    payload: map,
  });
};
